import React from 'react'
import { Link } from 'react-router'
import './SidebarApps.pcss'
import appStoreLogo from '../../assets/appstore.png'
import googlePlayLogo from '../../assets/playstore.png'

const SidebarApps = () => (
  <section className='sidebox'>
    <h3 className='sidebox-header'>
      <Link to='/sovellus' title='Ampparit sovellus'>
        <span>Ampparit sovellus</span>
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200' width='19' height='19' aria-hidden='true' className='widget-box__header__icon'>
          <circle cx='100' cy='100' r='80' fill='none' strokeWidth='14' />
          <line x1='85' y1='70' x2='120' y2='100' strokeWidth='12' />
          <line x1='85' y1='130' x2='120' y2='100' strokeWidth='12' />
        </svg>
      </Link>
    </h3>
    <div className='sidebox-content'>
      <div className='ampparit-app-links'>
        <a
          href='https://apps.apple.com/us/app/uutiset-ampparit-com/id673931936?itscg=30200&itsct=apps_box_badge&mttnsubad=673931936'
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Lataa Ampparit sovellus App Storesta'
          title='Lataa Ampparit sovellus App Storesta'
        >
          <img src={ appStoreLogo } alt='App Store' />
        </a>
        <a
          href='https://play.google.com/store/apps/details?id=com.ampparit.android&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Lataa Ampparit sovellus Google Playsta'
          title='Lataa Ampparit sovellus Google Playsta'
        >
          <img src={ googlePlayLogo } alt='Google Play' />
        </a>
      </div>
      <div className='ampparit-feedback-link'>
        <Link className='button' to='/palaute'>Anna palautetta</Link>
      </div>
    </div>
  </section>
)

export default SidebarApps
